<template>
<div class="section-box__column">
  <div class="title__box dot" v-bind:class="['dot__color--'+dot, 'title__box--txt-'+textColor]">

    <h2>
      <span
      v-for="(line, index) in title"
      :key='index'
      class="text-wrap">
      <transition
        appear 
        @appear="enterText"
        @beforeEnter="beforeEnterText"
        @enter="enterText"
        @leave="leaveText"
        @afterLeave="afterLeaveText">
        <span v-show="showChild" v-html="line"></span>
      </transition>
      </span>
    </h2>
  </div>

  <div class="section__contact--submenu" v-bind:class="this.specificationColor">
    <div class="section__contact--submenu--column">
    <ul>
      <lh class="text-wrap text-wrap__small">
        <transition appear
          @appear="enterText"
          @beforeEnter="beforeEnterText"
          @enter="enterText"
          @leave="leaveText"
          @afterLeave="afterLeaveText"><span v-show="showChild"><div class="dot"></div></span>
          </transition></lh>
      <li class="text-wrap text-wrap__small">
        <transition appear
          @appear="enterText"
          @beforeEnter="beforeEnterText"
          @enter="enterText"
          @leave="leaveText"
          @afterLeave="afterLeaveText">
          <span v-show="showChild">Rzeszow / Poland</span>
        </transition>
      </li>

      <li class="text-wrap text-wrap__small">
        <transition appear
          @appear="enterText"
          @beforeEnter="beforeEnterText"
          @enter="enterText"
          @leave="leaveText"
          @afterLeave="afterLeaveText">
          <span v-show="showChild">ul. Przemyslowa 14b</span>
        </transition>
      </li>
    </ul>
    <ul>
      <li class="text-wrap text-wrap__small">
        <transition appear
          @appear="enterText"
          @beforeEnter="beforeEnterText"
          @enter="enterText"
          @leave="leaveText"
          @afterLeave="afterLeaveText">
          <span v-show="showChild">m: hello[at]intervi.co.</span>
        </transition>
      </li>
     <li class="text-wrap text-wrap__small">
        <transition appear
          @appear="enterText"
          @beforeEnter="beforeEnterText"
          @enter="enterText"
          @leave="leaveText"
          @afterLeave="afterLeaveText">
          <span v-show="showChild">p:  +48 510 069 993</span>
        </transition>
      </li>
    </ul>
    </div>
    <div class="section__contact--submenu--column">
    <ul>
      <lh class="text-wrap text-wrap__small">
        <transition appear
          @appear="enterText"
          @beforeEnter="beforeEnterText"
          @enter="enterText"
          @leave="leaveText"
          @afterLeave="afterLeaveText"><span v-show="showChild"><div class="dot"></div></span>
          </transition></lh>
      <li class="text-wrap text-wrap__small">
        <transition appear
          @appear="enterText"
          @beforeEnter="beforeEnterText"
          @enter="enterText"
          @leave="leaveText"
          @afterLeave="afterLeaveText">
          <span v-show="showChild">San Francisco / U.S.A.</span>
        </transition>
      </li>
      <li class="text-wrap text-wrap__small">
        <transition appear
          @appear="enterText"
          @beforeEnter="beforeEnterText"
          @enter="enterText"
          @leave="leaveText"
          @afterLeave="afterLeaveText">
          <span v-show="showChild">Interactive Street 435</span>
        </transition>
      </li>
    </ul> 
      <ul>
      <li class="text-wrap text-wrap__small">
        <transition appear
          @appear="enterText"
          @beforeEnter="beforeEnterText"
          @enter="enterText"
          @leave="leaveText"
          @afterLeave="afterLeaveText">
          <span v-show="showChild">m: hello[at]intervi.co.</span>
        </transition>
      </li>
      <li class="text-wrap text-wrap__small">
        <transition appear
          @appear="enterText"
          @beforeEnter="beforeEnterText"
          @enter="enterText"
          @leave="leaveText"
          @afterLeave="afterLeaveText">
          <span v-show="showChild">p:  +00 754 456 321</span>
        </transition>
      </li>
    </ul> 
    </div>
  </div>


</div>

</template>

<script>
export default {
  name: "SectionTitle",
  data() {
    return {};
  },
  methods: {
    beforeEnterText: function(el) {
      TweenLite.to(el, 0, { y: "100%" });
    },
    enterText: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        { y: "100%" },
        {
          y: "0%",
          delay: 0.5,
          // ease: CustomEase.create("custom", ".86,.21,.87,.99"),
          onComplete: done
        }
      );
    },
    leaveText: function(el, done) {
      TweenMax.to(el, 1, {
        y: "-100%",
        // ease: CustomEase.create("custom", ".86,.21,.87,.99"),
        onComplete: done
      });
    },
    afterLeaveText: function(el) {
      TweenLite.to(el, 0, { y: "100%" });
    }
  },
  props: [
    "title",
    "dot",
    "textColor",
    "specificationColor",
    "agency",
    "client",
    "role",
    "url",
    "showChild"
  ]
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/SectionContactTitle.vue